export class LoginCtrl {
    constructor($location, $state, $stateParams, AuthService, InitService) {
        "ngInject";
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.AuthService = AuthService;
        this.InitService = InitService;
        this.email = '';
        this.password = '';
        this.loading = false;
    }
    submit() {
        let q = this.AuthService.login(this.email, this.password);
        let self = this;
        self.loading = true;
        q.then(
            function(success){
                if (success) {
                    self.InitService().then(function(){
                        let path = self.$stateParams.next || self.$state.href('r.in.top.home');
                        self.$location.url(path);
                    });
                } else {
                    self.loading = false;
                    self.password = '';
                }
            }
        );
    }
}

export class PasswordResetCtrl {
    constructor (AuthService) {
        "ngInject";
        this.AuthService = AuthService;
        this.complete = false;
        this.data = {
            email: ''
        }
    }

    submit() {
        let self = this;
        this.loading = true;
        this.AuthService
            .resetPassword(this.data.email)
            .then(
                () => { self.complete = true; },
                (response) => { self.errors = response.data; },
            )
            .finally(() => self.loading = false);
    }
}

export class PasswordConfirmCtrl {
    constructor (AuthService, $state, $growl, $stateParams) {
        "ngInject";
        this.AuthService = AuthService;
        this.$state = $state;
        this.$growl = $growl;
        this.data = {
            uid: $stateParams.uid,
            token: $stateParams.token,
            new_password: '',
            re_new_password: '',
        }
    }

    submit() {
        let self = this;
        this.loading = true;
        this.AuthService
            .confirmReset(this.data)
            .then(
                () => {
                    self.$growl.success('Password changed!');
                    self.$state.go('r.login');
                },
                (response) => { self.errors = response.data; },
            )
            .finally(() => self.loading = false);
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/ctrls.js